// @ts-nocheck
import React, { useState, useRef} from "react";
import SignatureCanvas from "react-signature-canvas";
import ReactMarkdown from "react-markdown";
import {Typography, Button, Grid, Modal, Backdrop, Fade, makeStyles} from "@material-ui/core";
import {markdownText} from "../../Constants/informedConsent";
import moment from "moment";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";

interface Props {
    setCanSubmit: React.Dispatch<React.SetStateAction<boolean>>;
    id: string;
}

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            width: "99%",
            margin: "0 auto"
        }
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 2),
        display: "flex",
        flexDirection: "column"
    },
    buttonGroup: {
        display: "flex",
        flexDirection: "row",
        margin: 10,
        justifyContent: "space-around"
    },
    button: {
        width: 100,
    },
    sigCanvas: {
        height: 300,
        width: 600,
        [theme.breakpoints.down("sm")]: {
            width: "100%"
        }
    },
    signature: {
        display: "flex",
        alignItems: "center",
        justifyItems: "center",
        alignSelf: "center",
        justifySelf: "center",
    },
    name: {
        margin: 0,
        marginLeft: 112,
    }
}));

const InformedConsent = ({id, setCanSubmit}: Props) => {
    const classes = useStyles();
    const [markdown, setMarkdown] = useState("");
    const [showSignature, setShowSignature] = useState(false);
    const [signature, setSignature] = useState<null | any>();
    const sigRef = useRef<SignatureCanvas>(null);
    let currentPath = window.location.search;
    const {firstName, lastName} = useSelector((state: RootState) => state?.userProfile);
    const brandingName = useSelector((state: RootState) => state?.branding?.name);

    const handleSigSubmit = () => {
        setSignature(sigRef.current?.toDataURL("image.png"));
        setShowSignature(false);
    };

    return (
        <div id={id}>
            <Typography gutterBottom variant="h2">
                Client Consent Form for Telehealth Services
            </Typography>
            <ReactMarkdown>{markdownText(brandingName)}</ReactMarkdown>
            {!currentPath.includes("?noheader") &&
            <>
                <Grid container justify="center">
                    <Grid item xs={12} sm={6}>
                        <Typography className={classes.signature}>
                            Signature:
                            <span>
                				{!showSignature && !signature &&
                                <Button style={{color: "#000"}} onClick={() => setShowSignature(true)}>Tap here to
                                    sign</Button>
                                }
                                {signature &&
                                <img src={signature} height={60} width={200} style={{cursor: "pointer"}} onClick={() => {
                                    setCanSubmit(false); setShowSignature(true);}}/>
                                }
                			</span>

                        </Typography>
                        {firstName && lastName
                        &&
                        <Typography class={classes.name}>
                            {firstName} {lastName}
                        </Typography>}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography style={{paddingTop: 10}} >Date: <span>{moment().format("MM/DD/YYYY hh:mm:ss a")}</span></Typography>
                    </Grid>
                </Grid>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={showSignature}
                    onClose={handleSigSubmit}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={showSignature}>
                        <div className={classes.paper}>
                            <Typography gutterBottom variant="h5">
                                Add Your Signature:
                            </Typography>
                            <SignatureCanvas
                                ref={sigRef}
                                penColor="black"
                                backgroundColor="rgba(238,238,238 ,1)"
                                canvasProps={{className: classes.sigCanvas}}
                                onEnd={() => setCanSubmit(true)}
                            />
                            <Typography gutterBottom variant="h5">
                            </Typography>
                            <div className={classes.buttonGroup}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    onClick={handleSigSubmit}
                                >
                                    Save
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.button}
                                    onClick={() => {setShowSignature(false); setCanSubmit(false);}}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Fade>
                </Modal>
            </>
            }
        </div>
    );
};

export default InformedConsent;
